<template>
    <div>
        <a-row :gutter="48">
            <a-col :md="5" :sm="24">
                <a-form-item label="工单标题">
                    <a-input v-model="listQuery.title" placeholder="请输入工单标题" allowClear @keyup.enter.native="getList" />
                </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
                <a-form-item label="模版数据">
                    <a-input v-model="listQuery.formData" placeholder="请输入模版数据" allowClear @keyup.enter.native="getList" />
                </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
                <a-form-item label="流程">
                    <a-select v-model="listQuery.process" placeholder="请选择流程" filterable allowClear @change="getList">
                        <a-select-option v-for="item in processValueList" :key="item.id" :value="item.id"> {{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col v-if="genre !== 'upcoming'" :md="5" :sm="24">
                <a-form-item v-if="genre !== 'upcoming'" label="当前处理人">
                    <a-select v-model="listQuery.processor" show-search :filter-option="filterOption" allowClear label-in-value placeholder="请输入当前处理人" :show-arrow="false" :not-found-content="null" @search="remoteUserList" @change="getList">
                        <a-select-option v-for="item in UserOptions" :key="item.userId" :value="item.userId">{{item.nickName}} </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col v-if="genre !== 'my-create'" :md="4" :sm="24">
                <a-form-item v-if="genre !== 'my-create'" label="申请人">
                    <a-select v-model="listQuery.creator" show-search :filter-option="filterOption" allowClear label-in-value placeholder="请输入当前处理人" :show-arrow="false" :not-found-content="null" @search="remoteUserList" @change="getList">
                        <a-select-option v-for="item in UserOptions" :key="item.userId" :value="item.userId"> {{item.nickName}} </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="48">
            <a-col :md="5" :sm="24">
                <a-form-item label="优先级">
                    <a-select v-model="listQuery.priority" placeholder="请选择优先级" allowClear @change="getList">
                        <a-select-option :value="1">一般</a-select-option>
                        <a-select-option :value="2">紧急</a-select-option>
                        <a-select-option :value="3">非常紧急</a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col v-if="genre !== 'upcoming'" :md="5" :sm="24">
                <a-form-item v-if="genre !== 'upcoming'" label="是否结束">
                    <a-select v-model="listQuery.isEnd" placeholder="请选择状态" allowClear @change="getList">
                        <a-select-option :value="1">是</a-select-option>
                        <a-select-option :value="0">否</a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
                <a-form-item label="创建时间">
                    <a-range-picker :placeholder="['开始时间', '结束时间']" @change="getList" @ok="getList" format="YYYY-MM-DD" v-model="timeRange" />
                </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
                <a-button @click="getList" type="primary" icon="search">查询</a-button>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import { getUserList } from '@/api/api'
    import { validatenull } from '@/utils/validate'
    import { getAction } from '@/api/manage'

    export default {
        name: 'WorkOrderSearch',
        props: ['genre'],
        data() {
            return {
                processValueList: [],
                timeRange: [],
                listQuery: {},
                UserOptions: [],
                url: {
                    list: "/workorder/pProcessInfo/list",
                },
            }
        },
        created() {
            this.getProcessList()
        },
        methods: {
            getList() {
                if (validatenull(this.timeRange)) {
                    this.listQuery.startTime = ''
                    this.listQuery.endTime = ''
                } else {
                    this.listQuery.startTime = this.timeRange[0]
                    this.listQuery.endTime = this.timeRange[1]
                }
                // 待办工单
                if (this.genre == 'upcoming') {
                    this.listQuery.classify = 1
                }else if (this.genre == 'my-create') {
                    // 我创建的
                    this.listQuery.classify = 2
                }else if (this.genre == 'related') {
                    // 我相关的
                    this.listQuery.classify = 3
                }else if (this.genre == 'all') {
                    // 所有的
                    this.listQuery.classify = 4
                }
                this.$emit('handleSearch', this.listQuery)
            },
            remoteUserList(query) {
                let params = {
                    username: query,
                    // realname: query,
                    // phone: query,
                    // workNo: query
                }
                let sqp = {}
                // sqp['superQueryParams'] = encodeURI(params)
                // sqp['superQueryMatchType'] = 'or'
                getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
                    this.UserOptions = res.result.records;
                })
            },
            getProcessList() {
                getAction(this.url.list, Object.assign({
                    current: 1,
                    pageSize: 999999,
                })).then((res) => {
                    if (res.success) {
                        this.processValueList = res.result.records || res.result
                    } else {
                        this.$message.warning(res.message)
                    }
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
        }
    }
</script>

<style scoped>



</style>